import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { RippLayout } from "../ui";
import { STAGES, TAG } from "./data";
import { useCycle, useScanned } from "./hooks";
import { Feeds } from "./Feeds";
import { Pipeline } from "./Pipeline";
import { Scan, Surface, Verify } from "./SpotA";
import { Buy, Monitor, Sell } from "./SpotB";

function Spotlight({ stage, token, cycle, scanned }) {
  const k = STAGES[stage].key;
  const body = { scan: <Scan scanned={scanned} />, surface: <Surface t={token} />, verify: <Verify t={token} />, buy: <Buy t={token} />, monitor: <Monitor t={token} />, sell: <Sell t={token} cycle={cycle} /> }[k];
  return (
    <div className="relative min-h-[340px] rounded-3xl border border-white/10 bg-[#070707] p-6 lg:p-10 overflow-hidden grid place-items-center" data-testid="engine-spotlight">
      <div className="pointer-events-none absolute -top-32 left-1/2 h-64 w-[70%] -translate-x-1/2 rounded-full bg-[#F5C451]/10 blur-3xl" />
      <AnimatePresence mode="wait">
        <motion.div key={`${cycle}-${k}`} className="w-full" initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -16 }} transition={{ duration: 0.35 }}>{body}</motion.div>
      </AnimatePresence>
    </div>
  );
}

function Clip({ stage, cycle, token, scanned }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white px-6 py-10 flex flex-col gap-7" data-testid="engine-clip">
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');"}</style>
      <div>
        <div className="text-[11px] tracking-[0.4em] text-[#F5C451]/80">RIPP MEME · THE ENGINE</div>
        <h1 className="mt-3 text-5xl font-black leading-[0.95]">Scan. Verify. Strike.<br /><span className="text-[#F5C451]" style={TAG}>Repeat.</span></h1>
      </div>
      <Spotlight stage={stage} token={token} cycle={cycle} scanned={scanned} />
      <Pipeline stage={stage} />
      <div className="mt-auto"><Feeds compact /></div>
      <div className="flex justify-between text-sm font-bold tracking-widest text-[#F5C451]"><span>ripp.xyz</span><span>Telegram: RIPP Labs Chat</span></div>
      <div className="text-center text-[10px] text-white/30">Illustrative example tokens · not real trades</div>
    </div>
  );
}

export function RippEngine() {
  const { stage, cycle, token } = useCycle();
  const scanned = useScanned();
  if (new URLSearchParams(window.location.search).has("clip")) return <Clip stage={stage} cycle={cycle} token={token} scanned={scanned} />;
  return (
    <RippLayout>
      <style>{"@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');"}</style>
      <section className="max-w-3xl" data-testid="engine-hero">
        <div className="text-[11px] tracking-[0.4em] text-[#F5C451]/80 mb-5">RIPP MEME · THE ENGINE</div>
        <h1 className="text-5xl lg:text-7xl font-black leading-[0.95]">Scan. Verify. Strike.<br /><span className="text-[#F5C451]" style={TAG}>Repeat.</span></h1>
        <p className="mt-6 text-white/55 text-sm lg:text-base">Watch the Meme Hunter work: every launch on Pump.fun and every call on X flows into the Hive. Grok reads the crowd, the Core checks for rugs, and RIPP enters, rides and exits on its own, around the clock.</p>
      </section>
      <section className="mt-14 grid lg:grid-cols-[300px_1fr] gap-6 items-start">
        <Feeds />
        <div className="space-y-8">
          <Spotlight stage={stage} token={token} cycle={cycle} scanned={scanned} />
          <Pipeline stage={stage} />
        </div>
      </section>
      <section className="mt-16 mb-10 flex flex-wrap items-center gap-4">
        <Link to="/ripp/lore" className="px-6 py-3 rounded-full bg-[#F5C451] text-black text-xs font-bold tracking-widest" data-testid="engine-lore-btn">READ THE LORE</Link>
        <a href="https://t.me/+FZyNGifYYd0zNWUx" target="_blank" rel="noreferrer" className="px-6 py-3 rounded-full border border-[#F5C451]/60 text-[#F5C451] text-xs font-bold tracking-widest hover:bg-[#F5C451]/10" data-testid="engine-telegram-btn">JOIN THE CHANNEL</a>
        <span className="text-[11px] text-white/30" data-testid="engine-disclaimer">Illustrative showcase with example tokens. Not real trades or results.</span>
      </section>
    </RippLayout>
  );
}
